import { useGetShipmentQuery, useGetShipmentPresentationQuery } from "../../../../timber/apis/Shipment.api";
import { ShipmentNameDisplay } from "../../../../timber/components/shipment/ShipmentDetail/ShipmentName";
import { toString as toStringShipment, PrimaryShipment } from "../../../../timber/types/models/Shipment";
import * as crudgen from "../../../../share";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import { Button, IconButton, Stack, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { Add as AddIcon } from "@mui/icons-material";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";
import {ID} from "../../../../types/global.d";
import {useLocationFormState} from "./ShipmentAddForm";
import ShipmentAddFormProvider from "./ShipmentAddFormProvider";

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {DescriptionAlert} from "../../../../share";
import { useFormContext } from 'react-hook-form';
import {useStateSession} from "../../../../hooks/useAuth";

const EMPTY_PAGINATION = {
    items: [],
    totalItems: 0,
    page: 0,
    pageSize: 12,
    numPages: 0
}

const AddDialog = ({name}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showDialog, setShowDialog] = React.useState<boolean>(false)
    const {setValue} = useFormContext()

    return (
        <>
            <IconButton aria-label={ t`Add Shipment` } onClick={() => setShowDialog(true)} size="small">
                <AddIcon />
            </IconButton>
            <Dialog
                open={showDialog}
                fullScreen={fullScreen}
                onClose={() => setShowDialog(false)}>
                <DialogTitle><Trans>Add Shipment</Trans></DialogTitle>
                <DialogContent>
                    <DescriptionAlert/>
                    <ShipmentAddFormProvider
                        successAction={
                            (data) => {
                                setValue(name, data.id)
                                setShowDialog(false)
                            }
                        }
                        cancelButton={<Button onClick={() => setShowDialog(false)}><Trans>Cancel</Trans></Button>}
                        initialFormState={useLocationFormState}
                        redirectPath="."
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}

const ShipmentFormSelect = ({type, name, label, prefix, required, onValueChange, filter = {}} :
                                        {type: string, name: string, label: string, prefix: string, required: boolean, onValueChange?: (option: any) => void, filter: {
                                                key: string,
                                                reportKey: string,
                                                shipmentAt: Date,
                                                cuttingIdRefs?: ID[],
                                                storageIdRefs?: ID[],
                                                shippingContractorUserIdRefs?: ID[],
                                                sourceLocationIdRefs?: ID[],
                                                buyerIdRefs?: ID[],
                                                roadCarrierIdRefs?: ID[],
                                                }
                                        })  => {

    const session = useStateSession()
    const [, setInputTerm, inputTerm] = useSearchDebounce();

    const { data = EMPTY_PAGINATION,
        isLoading,
        isFetching,
    } = useGetShipmentPresentationQuery({
      list: {
        page: 0,
        pageSize: 12,
      },
      filter: {
            key: inputTerm || '',
            keyOr: true,
            reportKey: inputTerm || '',
            reportKeyOr: true,
            ...filter,
      },
    })

    if (type === 'select') {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetShipmentQuery(PrimaryShipment.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringShipment }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><ShipmentNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/Shipments/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    } else {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetShipmentQuery(PrimaryShipment.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringShipment }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><ShipmentNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/Shipments/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    }
}

export default ShipmentFormSelect